import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileStateService {
  private readonly updatedSubject = new Subject<any>();
  readonly updated$ = this.updatedSubject.asObservable();

  publish(user: any): void {
    this.updatedSubject.next(user);
  }
}
